// --- 订单管理 --- //

export default [
  {
    name: 'orderInfo',
    path: '/stadiumSystem/:stadiumType/swimmingStadium/:stadiumId/orderManagement/orderInfo',
    meta: { title: '订单查询' },
    component: require('business/stadiumSystem/orderManagement/orderInfo/list.vue').default
  }
];
